module.exports = __webpack_public_path__ + "media/newstyle/images/icon-money-orange-4208e3a296b2d330839fd2878142695a.svg";